import { createSlice } from "@reduxjs/toolkit";
import { shipProfile } from "./thunk";

const shipSlice = createSlice({
  name: "ship",
  initialState: {
    shipinfo: null,
    status: "",
    setupComplete: localStorage.getItem("setupComplete") === "true",
    systemipaddress: localStorage.getItem("systemipaddress") || "",
    urlPath: localStorage.getItem("urlPath") || "",
  },
  reducers: {
    setSetupComplete: (state, action) => {
      state.setupComplete = action.payload;
      localStorage.setItem("setupComplete", action.payload);
    },
    setSystemConfig: (state, action) => {
      const { ipaddress, urlPath } = action.payload;
      state.systemipaddress = ipaddress;
      localStorage.setItem("systemipaddress", ipaddress);
      state.urlPath = urlPath;
      localStorage.setItem("urlPath", urlPath);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(shipProfile.pending, (state) => {
      state.status = "loading";
    });
    builder.addCase(shipProfile.rejected, (state) => {
      state.status = "error";
    });
    builder.addCase(shipProfile.fulfilled, (state, action) => {
      state.shipinfo = action.payload;
      state.status = "success";
    });
  },
});

export const { setSetupComplete, setSystemConfig } = shipSlice.actions;
export default shipSlice.reducer;
